import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table as MuiTable, TableContainer as MuiTableContainer, TableRow as MuiTableRow, TableBody, } from '@mui/material';
import { useCallback, useState, } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { skipProps, styled } from '../../utils';
import { Button } from '../Button';
import { Pagination } from '../Pagination/Pagination';
import { Typography } from '../Typography';
import { TableCell } from './TableCell';
import { TableHead } from './TableHead';
import { TableHeadRow } from './TableHeadRow';
import { TableRow } from './TableRow';
const ButtonStyled = styled(Button)(({ theme }) => ({
    display: 'block',
    margin: `${theme.spacing(3)} auto 0`,
}));
const TableContainerStyled = styled(MuiTableContainer, {
    shouldForwardProp: skipProps(['disableOverflowX']),
})(({ theme, disableOverflowX }) => ({
    //This is here because having overflowX on a parent element of a sticky element breaks the sticky functionality
    ...(disableOverflowX
        ? {
            [theme.breakpoints.up('md')]: {
                overflowX: 'unset',
            },
        }
        : {}),
}));
const loadMore = (rowLimit, setRowLimit, rowIncrease = 10) => {
    setRowLimit(rowLimit + rowIncrease);
};
export function getColSpan(columns, menuEntries, showIndex, isNoContentMessage) {
    const showMenu = menuEntries && menuEntries.length > 0;
    const showCloseButton = menuEntries && menuEntries.some((entry) => entry.action === 'expandRow');
    return (columns.length +
        (showIndex ? 1 : 0) +
        (showMenu ? 1 : 0) +
        (!isNoContentMessage && showCloseButton ? -1 : 0));
}
export function Table({ columns, data, subComponent, isExpandable, showIndex, open, menu, rowLimit, rowIncrease, subTable, stripes, seperateSubRow, noContentMessage, displayNullable, cellPadding = 'default', size = 'default', pagination = false, pageCount = 0, stickyTop, disableOverflowX, onSelectPage, alternativeCellAlignmentRight, noPaginationNoLoadMoreButton = false, alignTextCell, }) {
    const { t } = useTranslation();
    const [localRowLimit, setLocalRowLimit] = useState(rowLimit);
    const [selectedPage, setSelectedPage] = useState(1);
    const selectPage = useCallback((page) => {
        if (onSelectPage) {
            // TODO add loading animation add set true here
            void onSelectPage(page).then(() => {
                // TODO add loading animation add set false here
                setSelectedPage(page);
            });
        }
        else {
            setSelectedPage(page);
        }
    }, [onSelectPage]);
    return (_jsxs(TableContainerStyled, { disableOverflowX: disableOverflowX, children: [_jsxs(MuiTable, { children: [_jsx(TableHead, { stickyTop: stickyTop, cellSize: size, children: _jsx(TableHeadRow, { columns: columns, isExpandable: isExpandable, showIndex: showIndex, menuTitle: menu?.tableHeadTitle, stripes: stripes, cellPadding: cellPadding, alternativeCellAlignmentRight: alternativeCellAlignmentRight, size: size }) }), _jsx(TableBody, { children: data.length > 0 ? (data
                            .slice(pagination && rowLimit ? rowLimit * (selectedPage - 1) : 0, pagination && rowLimit ? rowLimit * selectedPage : localRowLimit)
                            .map((dataRow, i) => (_jsx(TableRow, { index: i, showIndex: showIndex, dataRow: dataRow, dataLength: data.length, columns: columns, SubComponent: subComponent, isExpandable: isExpandable, open: open, menuEntries: menu?.entries, menuIconVariant: menu?.iconVariant, menuIconDisabled: menu && menu.disabled ? menu?.disabled(dataRow) : false, subTable: subTable, seperateSubRow: seperateSubRow, stripes: stripes, displayNullable: displayNullable, cellPadding: cellPadding, alternativeCellAlignmentRight: alternativeCellAlignmentRight, size: size, alignTextCell: alignTextCell }, i)))) : (_jsx(MuiTableRow, { children: _jsx(TableCell, { colSpan: getColSpan(columns, menu ? menu.entries : [], showIndex, true), cellPadding: cellPadding, cellSize: size, align: alignTextCell ?? 'center', children: _jsx(Typography, { variant: "body1", children: noContentMessage || 'Es konnten keine Daten gefunden werden' }) }) })) })] }), !noPaginationNoLoadMoreButton &&
                !pagination &&
                localRowLimit &&
                data.length > localRowLimit && (_jsx(ButtonStyled, { variant: "outlined", onClick: () => loadMore(localRowLimit, setLocalRowLimit, rowIncrease), children: t('common:more_entries') })), !noPaginationNoLoadMoreButton && pagination && pageCount > 0 && (_jsx(PaginationContainerStyled, { children: _jsx(Pagination, { count: pageCount, page: selectedPage, onChange: (_event, page) => selectPage(page) }) }))] }));
}
const PaginationContainerStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
}));
